<template>
  <v-container id="regular-forms" fluid tag="section">
    <v-row>
      <v-col cols="12">
        <base-material-card
          color="primary"
          icon="mdi-account"
          :title="formValues.id ? $t('Edit Component') : $t('New Component')"
          class="px-5 py-3"
        >
          <v-progress-linear
            indeterminate
            rounded
            height="6"
            v-if="loading"
          ></v-progress-linear>
          <v-form
            v-else
            ref="form"
            autocomplete="new-password"
            lazy-validation
            @submit.prevent="saveItem()"
            class="mt-3"
          >
            <v-select
              v-model="formValues.type"
              :items="['flg1', 'flg2', 'st1', 'st2', 'ol']"
              :label="$t('type')"
              v-validate="'required'"
              required
              outlined
              data-vv-name="type"
              :error-messages="errors.collect('type')"
            ></v-select>
            <v-text-field
              v-model="formValues.description"
              :label="$t('description')"
              v-validate="'required'"
              required
              outlined
              data-vv-name="description"
              :error-messages="errors.collect('description')"
            ></v-text-field>
            <v-text-field
              v-model="formValues.max_area"
              :label="$t('max_area')"
              v-validate="'required'"
              type="number"
              required
              outlined
              data-vv-name="max_area"
              :error-messages="errors.collect('max_area')"
            ></v-text-field>
            <v-row>
              <v-col>
                <v-text-field
                  v-model="formValues.height_min"
                  :label="$t('height_min')"
                  v-validate="'required'"
                  required
                  outlined
                  data-vv-name="height_min"
                  :error-messages="errors.collect('height_min')"
                ></v-text-field>
              </v-col>
              <v-col>
                <v-text-field
                  v-model="formValues.height_max"
                  type="number"
                  :label="$t('height_max')"
                  v-validate="'required'"
                  required
                  outlined
                  data-vv-name="height_max"
                  :error-messages="errors.collect('height_max')"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <v-text-field
                  v-model="formValues.width_min"
                  type="number"
                  :label="$t('width_min')"
                  v-validate="'required'"
                  required
                  outlined
                  data-vv-name="width_min"
                  :error-messages="errors.collect('width_min')"
                ></v-text-field>
              </v-col>
              <v-col>
                <v-text-field
                  v-model="formValues.width_max"
                  type="number"
                  :label="$t('width_max')"
                  v-validate="'required'"
                  required
                  outlined
                  data-vv-name="width_max"
                  :error-messages="errors.collect('width_max')"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <v-text-field
                  v-model="formValues.proof_width"
                  type="number"
                  :label="$t('proof_width')"
                  v-validate="'required'"
                  required
                  outlined
                  data-vv-name="proof_width"
                  :error-messages="errors.collect('proof_width')"
                ></v-text-field>
              </v-col>
              <v-col>
                <v-text-field
                  v-model="formValues.proof_height"
                  type="number"
                  :label="$t('proof_height')"
                  v-validate="'required'"
                  required
                  outlined
                  data-vv-name="proof_height"
                  :error-messages="errors.collect('proof_height')"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-checkbox
              v-model="formValues.continuously_side_part"
              :label="$t('continuously_side_part')"
              outlined
              v-validate=""
              data-vv-name="continuously_side_part"
              :error-messages="errors.collect('continuously_side_part')"
            ></v-checkbox>
            <v-row>
              <v-col>
                <v-autocomplete
                  v-model="formValues.fillings"
                  :items="items"
                  :label="$t('filling')"
                  item-text="name"
                  item-value="id"
                  multiple
                  clearable
                  chips
                  outlined
                  data-vv-name="fillings"
                  :error-messages="errors.collect('fillings')"
                ></v-autocomplete>
              </v-col>
              <v-col>
                <v-select
                  v-model="formValues.filling_categories"
                  :items="categories"
                  :label="$t('filling_categories')"
                  item-text="name"
                  item-value="id"
                  v-validate="''"
                  multiple
                  clearable
                  chips
                  outlined
                  data-vv-name="filling_categories"
                  :error-messages="errors.collect('filling_categories')"
                ></v-select>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <v-checkbox
                  v-model="formValues.extracts_allowed"
                  :label="$t('extracts_allowed')"
                  v-validate=""
                  data-vv-name="extracts_allowed"
                  :error-messages="errors.collect('extracts_allowed')"
                ></v-checkbox>
              </v-col>
              <v-col> </v-col>
            </v-row>

            <div v-if="formValues.extracts_allowed">
              <v-row>
                <v-col>
                  <v-text-field
                    v-model="formValues.extracts_qty"
                    type="number"
                    :label="$t('extracts_qty')"
                    v-validate="'required'"
                    required
                    outlined
                    data-vv-name="extracts_qty"
                    :error-messages="errors.collect('extracts_qty')"
                  ></v-text-field>
                </v-col>
                <v-col>
                  <v-text-field
                    v-model="formValues.extracts_qty_max"
                    type="number"
                    :label="$t('extracts_qty_max')"
                    v-validate=""
                    outlined
                    data-vv-name="extracts_qty_max"
                    :error-messages="errors.collect('extracts_qty_max')"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <v-autocomplete
                    v-model="formValues.extract_fillings"
                    :items="fillings"
                    :label="$t('extract_fillings')"
                    item-text="name"
                    item-value="id"
                    multiple
                    outlined
                    chips
                    data-vv-name="extract_fillings"
                    :error-messages="errors.collect('extract_fillings')"
                  ></v-autocomplete>
                </v-col>
                <v-col>
                  <v-select
                    v-model="formValues.extract_filling_categories"
                    :items="categories"
                    :label="$t('extract_filling_categories')"
                    item-text="name"
                    item-value="id"
                    v-validate="''"
                    multiple
                    outlined
                    chips
                    data-vv-name="extract_filling_categories"
                    :error-messages="
                      errors.collect('extract_filling_categories')
                    "
                  ></v-select>
                </v-col>
              </v-row>
            </div>
            <v-card-actions class="pl-0">
              <v-btn color="primary" class="mr-4" @click="closeCallback()">
                {{ $t("back") }}
              </v-btn>
              <v-spacer></v-spacer>
              <v-btn color="primary" class="mr-4" @click="saveItem()">
                {{ $t("save") }}
              </v-btn>
            </v-card-actions>
          </v-form>
        </base-material-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import {
  fetchArticleItems,
  saveComponent,
  fetchComponent,
  deleteExtract,
  fetchArticleItemCategories
} from "../shared/services";

export default {
  name: "app-doorType-item",
  $_veeValidate: {
    validator: "new"
  },
  props: {
    id: null,
    closeCallback: null,
    saveCallback: null,
    value: {}
  },
  data() {
    return {
      dialog: false,
      formValues: {
        continuously_side_part: false
      },
      loading: true,
      items: [],
      categories: [],
      door_tpye_item: {
        name: "",
        items: [],
        required: false
      },
      headers: [
        { text: "Area", value: "area" },
        { text: "Item", value: "fillings" },
        { text: "Itemcategory", value: "item_categories" },
        { value: "delete" }
      ]
    };
  },
  created() {
    this.formValues = this.value;
  },
  mounted() {
    fetchArticleItems().then(res => {
      this.items = res.data;
    });
    fetchArticleItemCategories().then(res => {
      this.categories = res.data;
    });
    this.loading = false;
  },
  computed: {
    computedFormValues() {
      return {
        ...this.formValues
      };
    },
    extract() {
      return {
        component_id: this.formValues.id
      };
    },
    fillings() {
      return this.items.filter(item => {
        return item.type == "glass" || item.type == "filling";
      });
    }
  },
  methods: {
    initComponent() {
      if (this.formValues.id) {
        this.loading = true;
        fetchComponent(this.formValues.id).then(res => {
          this.formValues = res.data;
          this.loading = false;
        });
      }
    },
    initDoorTypeItem() {
      this.door_tpye_item = {
        name: "",
        items: [],
        required: false
      };
    },
    removeValue(item) {
      this.formValues.door_type_items = this.formValues.door_type_items.filter(
        door_tpye_item => door_tpye_item != item
      );
    },
    createExtract() {
      this.saveItem(true).then(() => {
        this.dialog = true;
      });
    },
    closeExtract() {
      this.dialog = false;
      this.initComponent();
    },
    async deleteExtract(item) {
      let resp = await deleteExtract(item.id);

      if (resp.success) {
        this.initComponent();

        this.$notification(resp.message, { type: "success" });
      } else {
        this.$notification(resp.message, { type: "error" });
      }
    },
    saveExtract() {
      this.dialog = false;
      this.initComponent();
      // fetchItem(this.$route.params.id).then(res => {
      //   this.formValues = res.data;
      //   this.formatDoorTypesResponse(res.data);
      // });
    },
    async saveItem(remain = false) {
      this.$validator.reset();
      this.$validator.validateAll();
      let resp = await saveComponent(
        this.formValues.id,
        this.computedFormValues,
        this.$validator
      );
      if (resp.success) {
        if (remain) {
          this.formValues = resp.data;
        } else {
          this.saveCallback();
        }
      }
    }
  },
  watch: {
    value: function(val) {
      this.formValues = val;
      this.initComponent();
    }
  }
};
</script>

<style lang="scss" scoped></style>
